import { useState } from "react";
import Hero from "../components/landing/Hero";
import TopNav from "../components/shared/TopNav";
import Feature from "../components/howitworks/Feature";
import FAQ from "../components/howitworks/FAQ";

import Process2 from "../components/howitworks/Process2";
import Process from "../components/howitworks/Process";
import SlideoverCalculator from "../components/howitworks/SlideoverCalculator";
import { LogoDev } from "@mui/icons-material";
import TeamLogoCloud from "../components/landing/TeamLogoCloud";

export default function HowItWorks({
  cart,
  reservationStages,
  setCart,
  setReservationStages,
  searchQuery,
  setSearchQuery,
}) {
  const [slideoverCalculatorOpen, setSlideoverCalculatorOpen] = useState(false);

  return (
    <div>
      <Process2 />
      {/* <Process /> */}
      <Feature
        slideoverCalculatorOpen={slideoverCalculatorOpen}
        setSlideoverCalculatorOpen={setSlideoverCalculatorOpen}
      />
      <SlideoverCalculator
        slideoverCalculatorOpen={slideoverCalculatorOpen}
        setSlideoverCalculatorOpen={setSlideoverCalculatorOpen}
        // cart={cart}
        // setCart={setCart}
        // reservationStages={reservationStages}
        // setReservationStages={setReservationStages}
      />
      <TeamLogoCloud />

      <FAQ />
    </div>
  );
}
